module.exports = __webpack_public_path__ + "static/poppins-v5-latin-600-c2b154f61de0c3278da5cfb2a3440371.svg";